































import { defineComponent } from "@vue/composition-api";
import { MessageLinkSubject } from "@scrile/api-provider/dist/api/MessageLinksProvider";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { getElement } from "@/lib/elementHelpers";
import emitter from "@/lib/emitter";
import { NotificationData } from "@/types";
import { EVENTS } from "@/const";
import BaseInputBox from "@/components/BaseInputBox";
import BaseSendMessage from "@/components/BaseSendMessage";
import SendMessageController from "@/components/SendMessageController";

export default defineComponent({
  name: "SubjectReaction",
  components: { BaseSendMessage, BaseInputBox, SendMessageController },
  props: {
    recipientId: { type: String, required: true },
    linkSubject: { type: Object as () => MessageLinkSubject, required: true },
    notification: { type: Object as () => NotificationData },
    placeholder: { type: String, default: "" },
    transparent: { type: Boolean, default: false },
    forceFocus: { type: Boolean, default: false },
  },
  setup() {
    const { authUser } = useAuthUser();
    return {
      authUser,
    };
  },
  data() {
    return {
      value: "",
      focused: false,
    };
  },
  computed: {
    hasText(): boolean {
      return this.value.trim().length > 0;
    },
  },
  methods: {
    async onMessageSend(promise: Promise<Message[]>) {
      const messages = await promise;
      if (messages.length > 0) {
        this.value = "";
        this.$emit("sent");
        this.notification && emitter.emit(EVENTS.NOTIFICATION_SHOW, this.notification);
        messages.forEach(message => emitter.emit(EVENTS.MESSAGES_NEW_MESSAGE, message));
      }
    },
    async onFocus() {
      this.focused = true;
      await this.$nextTick();
      const txtArea = getElement(this.$el).querySelector("textarea");
      txtArea && txtArea.focus();

      if (!this.authUser) {
        this.focused = false;
        emitter.emit(EVENTS.SHOW_LOGIN_SIGNUP_MODAL);
      }
    },
    onInput(v: string) {
      this.value = v;
      this.$emit("input", v);
    },
  },
  mounted() {
    if (this.forceFocus) this.onFocus();
  },
});
